import { chain } from 'wagmi';
import fancyBearStakingABI from '../abis/fancyBearStaking.abi.json';
import fancyBearStakingRewardV2ABI from '../abis/fancyBearStakingRewardV2.abi.json';
import fancyBearsABI from '../abis/fancyBears.abi.json';
import honeyTokenABI from '../abis/honeyToken.abi.json';
import levelsABI from '../abis/levels.abi.json';

const isTestnet = parseInt(process.env.REACT_APP_USE_TESTNET!, 10) === 1;

const unstakeCooldownFromEnv = parseInt(
  process.env.REACT_APP_UNSTAKE_COOLDOWN!,
  10
);

const config = {
  environment: process.env.NODE_ENV as 'production' | 'development',
  isTestnet,

  sentry: {
    sentryDsn: process.env.REACT_APP_SENTRY_DSN!,
  },

  ga: {
    gaId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID!,
  },

  infura: {
    infuraId: process.env.REACT_APP_INFURA_ID!,
  },

  quicknode: {
    rpcUrl: process.env.REACT_APP_QUICKNODE_RPC_URL!,
  },

  chains: isTestnet ? [chain.rinkeby] : [chain.mainnet],

  unstakeCooldown: isFinite(unstakeCooldownFromEnv) ? unstakeCooldownFromEnv : 0,

  contracts: {
    fancyBearsContract: {
      address: process.env.REACT_APP_FANCY_BEARS_CONTRACT_ADDRESS!,
      interface: fancyBearsABI,
    },
    fancyBearStakingContract: {
      address: process.env.REACT_APP_FANCY_BEAR_STAKING_CONTRACT_ADDRESS!,
      interface: fancyBearStakingABI,
    },
    fancyBearStakingRewardContractV2: {
      address:
        process.env.REACT_APP_FANCY_BEAR_STAKING_REWARD_V2_CONTRACT_ADDRESS!,
      interface: fancyBearStakingRewardV2ABI,
    },
    honeyTokenContract: {
      address: process.env.REACT_APP_HONEY_TOKEN_CONTRACT_ADDRESS!,
      interface: honeyTokenABI,
    },
    levelsContract: {
      address: process.env.REACT_APP_LEVELS_CONTRACT_ADDRESS!,
      interface: levelsABI,
    },
  },

  urls: {
    fancyBearsImagesUrl: process.env.REACT_APP_FANCY_BEAR_IMAGES_URL!,
    fancyBearsCollectionUrl: process.env.REACT_APP_FANCY_BEARS_COLLECTION_URL!,
    publicUrl: process.env.PUBLIC_URL!,
    apiUrl: process.env.REACT_APP_API_URL!,
    buyEthUrl: process.env.REACT_APP_BUY_ETH_URL!,
    buyHoneyUrl: process.env.REACT_APP_BUY_HONEY_URL!,
    learnMoreUrl: process.env.REACT_APP_LEARN_MORE_URL!,
    discordUrl: process.env.REACT_APP_DISCORD_URL!,
    twitterUrl: process.env.REACT_APP_TWITTER_URL!,
  },
};

export default config;
